import React, { memo } from 'react';
import { StatusCodes } from 'http-status-codes';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import Container from 'react-bootstrap/Container';

import PoweredBy from '../Component/General/PoweredBy';

interface Props {
    retry?: boolean;
    amountRequests?: number;
    isValidator?: boolean;
    errorCode?: number;
}

const ErrorPage: React.FC<Props> = (props: Props) => {
    const { retry, amountRequests, isValidator = false, errorCode } = props;

    const isPreconditionError = errorCode === StatusCodes.PRECONDITION_REQUIRED;

    const title = isPreconditionError ? 'Uw Adviesbox is niet actueel' : 'Er is iets mis gegaan';

    return (
        <>
            <Container className="loading-container">
                <div className="loading-container__not-found">
                    <h2>{title}</h2>
                    <ExclamationTriangleFill />
                    {retry && <strong>We proberen het opnieuw! ({amountRequests})</strong>}
                    {!retry && !isValidator && <strong>Het ophalen van de data is niet gelukt.</strong>}
                    {!retry && isValidator && !isPreconditionError && (
                        <strong>Er is een bericht gestuurd aan onze service desk. Excuses voor het ongemak.</strong>
                    )}
                    {!retry && isValidator && isPreconditionError && (
                        <strong>Update uw pakket en dien de aanvraag opnieuw in.</strong>
                    )}
                </div>
            </Container>
            <PoweredBy />
        </>
    );
};

export default memo(ErrorPage);
